import client from '@helpers/client'

export default {
    install(app) {
        app.config.globalProperties.$client = client;
    }
};
